import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

// Register all plugins once, centrally
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.tz.setDefault('Asia/Kolkata');

// Global offset (in milliseconds) between server time and local time
let serverOffset = 0;

/**
 * Called by ServerTimeProvider once the server time is fetched.
 * Updates the global offset used by the app's dayjs wrapper.
 */
export const setServerTimeOffset = (offset) => {
  serverOffset = offset;
};

/**
 * A drop-in replacement for dayjs.
 * - When called with NO arguments, returns a dayjs object set to the
 *   server-synced current time (Date.now() + serverOffset).
 * - When called WITH arguments (e.g. a date string), it behaves
 *   exactly like the original dayjs.
 */
const appDayjs = (...args) => {
  if (args.length === 0) {
    return dayjs(Date.now() + serverOffset);
  }
  return dayjs(...args);
};

// Copy all static properties & methods (extend, isDayjs, locale, tz, etc.)
// so that appDayjs can be used as a full replacement everywhere.
Object.keys(dayjs).forEach((key) => {
  appDayjs[key] = dayjs[key];
});

export default appDayjs;
